import API from "@/models/API";

export default class Customers {
    constructor(item = {}) {
        this.company_id = item.company_id || null;
        this.store_id = item.store_id || null;
        this.user_id = item.user_id || null;
        this.card_numbers_activated = item.card_numbers_activated || null;
        this.mobile = item.mobile || "";
        this.first_name = item.first_name || "";
        this.last_name = item.last_name || "";
        this.email = item.email || "";
        this.birth_date = item.birth_date || "";
        this.gender = item.gender || "";
        this.zipcode = item.zipcode || "";
        this.city = item.city || "";
        this.address = item.address || "";
        this.total_transactions = item.total_transactions || 0;
        this.total_price = item.total_price || 0;
        this.total_points = item.total_points || 0;
        this.active_total_transactions = item.active_total_transactions || 0;
        this.active_total_price = item.active_total_price || 0;
        this.active_total_points = item.active_total_points || 0;
        this.online_status = item.online_status || "";
        this.region_name = item.store_name || "";
        this.region_name = item.store_name || "";
        this.last_transaction_date = item.last_transaction_date || "";
        this.region_id = item.region_id || null;
        this.card_numbers_applied = item.card_numbers_applied || "";
        this.is_monthly = item.is_monthly || false;
        this.is_active = item.is_active || false;
        this.created_at = item.created_at || "";
        this.updated_at = item.updated_at || "";

        // this.county_id = item.county_id || null;
        // this.form_date = item.form_date || "";
        // this.notifications = item.notifications || null
    }

    static getAll = ( query, filters) =>
         API.get(`/companies/${localStorage.getItem("storeId")}/customers/store/${query + filters}`);

    static get = (childId, query, filters) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/customers/store/${childId + query + filters}`);

    static getExportedFileStatus = () =>
        API.get(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-customers`
        );

    static exportFile = item =>
        API.post(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-customers`,
            item
        );

    static deleteExportedFile = id =>
        API.delete(
            `/companies/${localStorage.getItem(
                "storeId"
            )}/export/company-customers/${id}`
        );

    static getStores = query =>
        API.get(`/companies/${localStorage.getItem("storeId")}/company-stores${query}`);
}
